<script lang="ts" setup>
import { useTheme } from 'vuetify'
import mfcIconGrey from '@images/icons/mfc-grey.svg'
import mfcIconWhite from '@images/icons/mfc-white.svg'

const vuetifyTheme = useTheme()

const mfcIcon = computed(() => {
  return vuetifyTheme.current.value.dark ? mfcIconWhite : mfcIconGrey
})
</script>

<template>
  <VImg
    :src="mfcIcon"
    class="layout-horizontal-nav__logo mr-2"
  />
</template>
